var _920 = require('./patch/9.2.0');

module.exports = [].concat(_920);